module.exports = __webpack_public_path__ + "static/media/Urban Colors Art_5_t.0644dbc2.jpg";